module.exports = __webpack_public_path__ + "organizations.95ba371bb58d83c15d53131fe8aaf5fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/organizations.svg
// module id = 336
// module chunks = 0